/** @format */

import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { Gear } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type MenuItem = {
  title: string;
  href: string;
  icon: any;
  onClick?: () => void;
};

type DropdownProps = {
  items: MenuItem[];
  size?: string;
  contentW?: string;
  gear?: boolean;
};

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function NoteDropdown({
  items,
  size = "h-5 w-5",
  contentW = "w-[150px]",
  gear = false,
}: DropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center text-gray-400 focus:outline-none">
        <span className="sr-only">Open options</span>
        {gear ? (
          <Gear
            className={
              "text-gray-400 dark:text-gray-100 hover:text-gray-200 " + size
            }
            aria-hidden="true"
          />
        ) : (
          <EllipsisVerticalIcon
            className={
              "text-gray-400 dark:text-gray-100 hover:text-gray-200 " + size
            }
            aria-hidden="true"
          />
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className={`bg-white dark:bg-gray-800 dark:text-white`}
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.title}
            onClick={item.onClick}
            className={
              (["Delete Note", "Delete Template"].includes(item.title)
                ? "text-red-500 hover:text-red-800 dark:hover:text-red-400"
                : "") +
              " text-nowrap flex items-center px-1 py-1.5 text-sm hover:bg-gray-25/50 dark:hover:bg-gray-600 cursor-pointer"
            }
          >
            <span className="mr-2">{item.icon}</span>
            {item.title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
